import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EntityTypeUserView, SearchUsersParameters, UserView } from '@api-proxies';
import { UserService } from '@http/clients/user.service';
import { EntityUser } from '@models/EntityUser';
import { EditorComponentBase, GenericTypeAheadMultiselectComponent, ObjectExtensionsService } from 'ngx-lib';
import { CustomMenuItemComponent } from '../../custom-menu-item/custom-menu-item.component';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-entity-user-editor',
    templateUrl: './entity-user-editor.component.html',
    styleUrls: ['./entity-user-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, ValidationErrorMessageComponent, CustomMenuItemComponent]
})
export class EntityUserEditorComponent extends EditorComponentBase<EntityTypeUserView[]> implements OnInit {
    userItems?: EntityUser[];
    selectedUsers?: EntityUser[];

    constructor(
        private readonly userService: UserService,
        private readonly objectExtensionService: ObjectExtensionsService
    ) {
        super();
    }

    ngOnInit(): void {
        if (this.bindingProperty) {
            const mappedResults = this.bindingProperty.map((x) => EntityUser.fromInterface(x));
            this.selectedUsers = mappedResults;
        }
    }

    async onUserTextChange(event: string) {
        const results: UserView[] = await this.userService.search({
            filterText: event,
            isActive: true
        } as SearchUsersParameters);

        this.userItems = results.map((x) => EntityUser.fromUserView(x));
    }

    onSelectedUserChange(event: EntityUser[]) {
        this.bindingProperty = this.objectExtensionService.clone(event) as EntityTypeUserView[];
        this.valueChange.emit();
        this.validate();
    }
}
